import { useEffect } from "react";

// For click-to-open menus: close on a click outside the menu, or on Escape.
// Not onMouseLeave — a menu whose panel renders with any gap from its trigger
// (common with `top: calc(100% + Npx)` dropdowns) fires a spurious mouseleave
// as the cursor crosses that gap on the way to a link inside it, closing the
// menu before the click can land.
export function useClickOutside(ref, onOutside, active) {
  useEffect(() => {
    if (!active) return;
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onOutside();
    };
    const handleKey = (e) => {
      if (e.key === "Escape") onOutside();
    };
    document.addEventListener("mousedown", handleClick);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("keydown", handleKey);
    };
  }, [active, ref, onOutside]);
}
